import React from 'react';
import { Mail, MapPin, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';

const footerLogo = new URL('../assets/logo-ph-white.svg', import.meta.url).href;

const XIcon = () => (
  <svg
    className="w-5 h-5 inline-block text-[#F4F7F9] transition-colors duration-200"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
  </svg>
);

export function Footer() {
  return (
    <footer className="bg-[#1f2937] text-[#F4F7F9]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-4 lg:col-span-1">
            <div className="flex items-center gap-2">
              <img src={footerLogo} alt="PleromaHealth" className="h-10" />
            </div>
            <p className="text-[#F4F7F9]/70">
              Foresight in. Friction out. Healthcare AI delivered as software you own.
            </p>
            <div className="flex gap-4">
              <a
                href="https://x.com/pleromahealth"
                target="_blank"
                rel="noopener noreferrer"
                className="group h-10 w-10 bg-[#4B5563] hover:bg-[#34AFFB] rounded-full flex items-center justify-center transition-colors"
                aria-label="X, formerly Twitter"
              >
                <XIcon />
              </a>
              <a
                href="https://linkedin.com/company/pleromahealth"
                target="_blank"
                rel="noopener noreferrer"
                className="h-10 w-10 bg-[#4B5563] hover:bg-[#34AFFB] rounded-full flex items-center justify-center transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white mb-4 font-semibold">Company</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="hover:text-[#34AFFB] transition-colors">About Us</Link></li>
              <li><Link to="/insights" className="hover:text-[#34AFFB] transition-colors">Insights</Link></li>
              <li><Link to="/#contact" className="hover:text-[#34AFFB] transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <h3 className="text-white mb-4 font-semibold">Solutions</h3>
            <ul className="space-y-3">
              <li><Link to="/healthbridge" className="hover:text-[#34AFFB] transition-colors">HealthBridge</Link></li>
              <li><Link to="/who-we-serve/providers-and-acos" className="hover:text-[#34AFFB] transition-colors">Providers &amp; ACOs</Link></li>
              <li><Link to="/who-we-serve/payers" className="hover:text-[#34AFFB] transition-colors">Payers &amp; Health Plans</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white mb-4 font-semibold">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#34AFFB] flex-shrink-0 mt-1" />
                <span>Austin, TX and Dallas, TX</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-[#34AFFB] flex-shrink-0" />
                <a href="mailto:info@pleromahealth.com" className="hover:text-[#34AFFB] transition-colors">info@pleromahealth.com</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#4B5563] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#F4F7F9]/70">
            © PleromaHealth LLC. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="hover:text-[#34AFFB] transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-service" className="hover:text-[#34AFFB] transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
